import { DateRangePicker } from '@src/common/components/dates/DateRangePicker';
import type {
  DateRange,
  SearchPermitFilters,
} from '@src/permits/services/PermitApplicationClient';
import { useTranslation } from 'react-i18next';

interface Props {
  onFilterChange: (filters: SearchPermitFilters) => void;
  value?: DateRange;
}

export const SubmissionDateFilter = ({ onFilterChange, value }: Props) => {
  const { t } = useTranslation();

  return (
    <DateRangePicker
      label={t('permitSearch.submissionDate')}
      value={{
        from: value?.from ? new Date(value.from) : undefined,
        to: value?.to ? new Date(value.to) : undefined,
      }}
      onChange={(dateRange) => {
        onFilterChange({
          submissionDate: {
            from: dateRange.from?.toISOString(),
            to: dateRange.to?.toISOString(),
          },
        });
      }}
    />
  );
};
